import capitalize from "lodash-es/capitalize";

import { get as lodashGet } from "lodash-es";
import { useMemo } from "react";
import type { CreateDataObjectTypesModelWithTranslationsReturn } from "@certa/queries/types/dataObjectsAPIs.types";
import {
  usePreSelectedWorkflowDataObjectTags,
  useExcludedWorkflowDataObjectTags
} from "./usePreSelectedWorkflowKinds";

const getLabel = (
  dataObjectType: CreateDataObjectTypesModelWithTranslationsReturn[0]
) => {
  return (
    lodashGet(dataObjectType.translatedUiSchema, "display_names.plural") ||
    dataObjectType.uiSchema?.display_names?.plural ||
    dataObjectType.uiSchema?.display_names?.singular ||
    capitalize(dataObjectType.tag)
  );
};

export const useGetDataObjectOptions = (
  dataObjects?: CreateDataObjectTypesModelWithTranslationsReturn
) => {
  const excludedWorkflowDatObjectTags: string[] =
    useExcludedWorkflowDataObjectTags();
  const preSelectedDataObjectTags: string[] =
    usePreSelectedWorkflowDataObjectTags();

  const dataObjectOptions = useMemo(() => {
    return (
      dataObjects
        ?.filter(
          dataObject => !excludedWorkflowDatObjectTags.includes(dataObject.tag)
        )
        .sort((a, b) => {
          const isPreSelectedA = preSelectedDataObjectTags.includes(a.tag);
          const isPreSelectedB = preSelectedDataObjectTags.includes(b.tag);
          // Sort preselected items to the top
          if (isPreSelectedA && !isPreSelectedB) return -1;
          if (!isPreSelectedA && isPreSelectedB) return 1;
          // For items with same preselected status, maintain alphabetical order

          return getLabel(a).localeCompare(getLabel(b));
        })
        .map(dataObjectType => {
          const label = getLabel(dataObjectType);
          return {
            label,
            value: dataObjectType.tag
          };
        }) || []
    );
  }, [dataObjects, excludedWorkflowDatObjectTags, preSelectedDataObjectTags]);

  return dataObjectOptions;
};
